import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const SignalRSubscription = () => (
  <ComponentDocs
    name="<SignalR.Subscription/>"
    entry="SignalRSubscription"
    propsEntry="SignalRSubscriptionProps"
  >
    <ComponentExample
      name="Multiple Subscriptions"
      rawImport={import(
        "examples/SignalR/SignalRSubscription/MultipleSubscriptionsExample?raw"
      )}
    />
  </ComponentDocs>
);

export default SignalRSubscription;
